module.exports = __webpack_public_path__ + "img/racecourse-fairview-turf-2000.49715fdd.svg";